import React from 'react';
import { MuiThemeProvider } from '@material-ui/core';
import { createTheme } from '@material-ui/core/styles';
import { observer } from 'mobx-react';
import '../styles/App.scss';
import TagManager from 'react-gtm-module';
import LoadingRipleyComponent from '../components/utils/LoadingRipleyComponent';
import appStore from '../stores/AppStore.js';
import ViewConstants from './../utils/ViewConstants';
import GenericErrorComponent from './GenericErrorComponent';
import PreguntasSeguridadComponent from './PreguntasSeguridadComponent';
import PopUpComponent from './utils/PopUpComponent';
import SolicitarNuevaPortabilidadComponent from './SolicitarNuevaPortabilidad';
import FirmasComponent from './utils/FirmasComponent';
import IngresoDatosClienteComponent from './IngresoDatosClienteComponent';
import IniciarSolicitud from './IniciarSolicitud';
import SeleccionBancoComponent from './utils/SeleccionBancoComponent';
import MensajeFinal from './MensajeFinal';
import ContratarProductosComponent from './ContratarProductosComponent';
import MensajeRetractoComponent from './MensajeRetractoComponent';
import ConfirmacionProductosPortarComponent from './ConfirmacionProductosPortarComponent';
import OfertaComponent from './utils/OfertaComponent';
import popup from '../stores/PopupStore';

const muiTheme = createTheme({
  typography: {
    useNextVariants: true,
    fontFamily: 'Montserrat',
  },
  palette: {
    primary: { main: '#523178', contrastText: '#fff' },
    primary1ColorFaded: '#523178',
    secondary: { main: '#f2ad4b', contrastText: '#fff' },
    colorTexto: '#523178',
  },
});

TagManager.initialize({ gtmId: ViewConstants.TAG_MANAGER_API_KEY });

class AppComponent extends React.Component {
  constructor(props) { // eslint-disable-line
    super(props);
  }

  renderCurrentView = () => {
    let content;
    switch (appStore.navigationSection) {
      case ViewConstants.ETAPA_DATOSCLIENTE:
        content = <IngresoDatosClienteComponent />;
        break;
      case ViewConstants.ETAPA_PREGUNTASSEGURIDAD:
        content = <PreguntasSeguridadComponent />;
        break;
      case ViewConstants.ETAPA_LISTADO_SOLICITUDES:
        content = <IniciarSolicitud />;
        break;
      case ViewConstants.ETAPA_SELECCION_BANCO:
        content = <SeleccionBancoComponent />;
        break;
      case ViewConstants.ETAPA_NUEVA_PORTABILIDAD:
        content = <SolicitarNuevaPortabilidadComponent />;
        break;
      case ViewConstants.ETAPA_PRODUCTOS_A_CONTRATAR:
        content = <ContratarProductosComponent />;
        break;
      case ViewConstants.ETAPA_RESUMEN_Y_FIRMA:
        content = <FirmasComponent />;
        break;
      case ViewConstants.ETAPA_FINAL_SOLICITUD:
        content = <MensajeFinal />;
        break;
      case ViewConstants.ETAPA_CONFIRMACION_PRDUCTOS:
        content = <ConfirmacionProductosPortarComponent />;
        break;
      case ViewConstants.ETAPA_OFERTA:
        content = <OfertaComponent />;
        break;
      case ViewConstants.ETAPA_OFERTA_ACEPTADA:
        content = <MensajeRetractoComponent />;
        break;
      default:
        content = <GenericErrorComponent />;
        break;
    }

    return content;
  };
  render() {
    const content = this.renderCurrentView();

    return (
      <MuiThemeProvider theme={muiTheme}>
        <div className="containerPrincipal">
          <div className="containerContenido">
            {content}
            {<PopUpComponent title={popup.popupData.title} message={popup.popupData.message} btns={popup.popupData.btns} />}
          </div>
          <LoadingRipleyComponent />
        </div>
      </MuiThemeProvider>
    );
  }
}

AppComponent.defaultProps = {};
//export default AppComponent;
export default observer(AppComponent);
